import { registerPlugin } from "@capacitor/core";

export interface StashtAppGroupPlugin {
  saveTokens(options: { accessToken?: string; refreshToken?: string }): Promise<{ success: boolean }>;
  getTokens(): Promise<{ accessToken: string | null; refreshToken: string | null }>;
  clearTokens(): Promise<{ success: boolean }>;
  setApiUrl(options: { url: string }): Promise<{ success: boolean }>;
  saveAuthToken?(options: { token: string }): Promise<{ success: boolean }>;
  getAuthToken?(): Promise<{ token: string | null }>;
  clearAuthToken?(): Promise<{ success: boolean }>;
}

const ACCESS_KEY = "stasht_access_token";
const REFRESH_KEY = "stasht_refresh_token";

const StashtAppGroup = registerPlugin<StashtAppGroupPlugin>("StashtAppGroup", {
  web: {
    async saveTokens(options: { accessToken?: string; refreshToken?: string }) {
      const { accessToken, refreshToken } = options;
      if (accessToken) {
        localStorage.setItem(ACCESS_KEY, accessToken);
      }
      if (refreshToken) {
        localStorage.setItem(REFRESH_KEY, refreshToken);
      }
      return { success: true };
    },
    async getTokens() {
      const accessToken = localStorage.getItem(ACCESS_KEY);
      const refreshToken = localStorage.getItem(REFRESH_KEY);
      return { accessToken, refreshToken };
    },
    async clearTokens() {
      localStorage.removeItem(ACCESS_KEY);
      localStorage.removeItem(REFRESH_KEY);
      return { success: true };
    },
    async setApiUrl() {
      // No-op on web - API URL is handled by Vite env vars
      return { success: true };
    },
    // Legacy fallbacks for environments that call the old methods
    async saveAuthToken(options: { token: string }) {
      return this.saveTokens({ accessToken: options.token });
    },
    async getAuthToken() {
      const accessToken = localStorage.getItem(ACCESS_KEY);
      return { token: accessToken };
    },
    async clearAuthToken() {
      return this.clearTokens();
    },
  },
});

export { StashtAppGroup };
